import React from 'react'
import PayrollCalculator from '../components/PayrollCalculator'
import {MapPin, DollarSign, TrendingUp} from 'lucide-react'

const VirginiaCalculatorPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-emerald-50 py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center mb-4">
              <MapPin className="w-10 h-10 text-blue-800 mr-3" />
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
                Virginia Pay Calculator
              </h1>
            </div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Calculate your Virginia paycheck with precise state tax calculations. Free pay calculator for Virginia residents and workers.
            </p>
          </div>

          {/* Calculator with VA pre-selected */}
          <PayrollCalculator defaultState="Virginia" />
        </div>
      </section>

      {/* SEO Content */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Pay Calculator Virginia - Accurate State Tax Withholding
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Virginia uses a graduated income tax system with four tax brackets ranging from 2% to 5.75%. Our Virginia pay calculator applies the correct tax rate based on your income level and filing status. Whether you're working in Richmond, Virginia Beach, Norfolk, or anywhere across the Commonwealth, this tool provides accurate paycheck estimates.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Virginia's tax structure is straightforward, with no local income taxes in most areas. Our calculator factors in both Virginia state taxes and federal withholdings (income tax, Social Security, Medicare) to show your exact net pay per paycheck.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-blue-50 p-6 rounded-lg">
              <DollarSign className="w-8 h-8 text-blue-800 mb-3" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Virginia Tax Brackets 2024</h3>
              <ul className="text-gray-600 space-y-2">
                <li>• 2% on income up to $3,000</li>
                <li>• 3% on income $3,001 - $5,000</li>
                <li>• 5% on income $5,001 - $17,000</li>
                <li>• 5.75% on income over $17,000</li>
              </ul>
            </div>

            <div className="bg-emerald-50 p-6 rounded-lg">
              <TrendingUp className="w-8 h-8 text-emerald-700 mb-3" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Calculator Benefits</h3>
              <ul className="text-gray-600 space-y-2">
                <li>• Real-time calculations</li>
                <li>• Current Virginia tax rates</li>
                <li>• Multiple pay frequency options</li>
                <li>• Detailed deduction breakdown</li>
              </ul>
            </div>
          </div>

          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Understanding Your Virginia Paycheck
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Your Virginia paycheck reflects multiple deductions. Federal income tax is calculated first based on your W-4 form and IRS tax tables. Virginia state income tax follows, using the state's four-bracket progressive system. Finally, FICA taxes are deducted at the standard 7.65% rate (6.2% Social Security + 1.45% Medicare). Our pay calculator automatically computes all these deductions, showing you exactly how your gross pay translates to take home pay.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-blue-800 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Calculate Your Virginia Net Pay
          </h2>
          <p className="text-blue-100 mb-6">
            Accurate Virginia paycheck calculator with state and federal tax estimates.
          </p>
          <a
            href="#calculator"
            className="inline-block bg-white text-blue-800 font-semibold px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Calculate Now
          </a>
        </div>
      </section>
    </div>
  )
}

export default VirginiaCalculatorPage
